import { useEffect, useState } from "react";
import { CITIES } from "@/lib/categories";

function norm(s) {
  return (s || "").toLocaleLowerCase("tr")
    .replace(/i̇/g, "i").replace(/ı/g, "i").replace(/İ/g, "i")
    .replace(/ş/g, "s").replace(/ç/g, "c").replace(/ğ/g, "g").replace(/ü/g, "u").replace(/ö/g, "o")
    .replace(/[^a-z]/g, "");
}

let cached = null;

export function useAutoCity() {
  const [city, setCity] = useState(cached);

  useEffect(() => {
    if (cached) { setCity(cached); return; }
    let alive = true;
    fetch("https://ipwho.is/")
      .then((r) => r.json())
      .then((d) => {
        const cand = [d.region, d.city].filter(Boolean).map(norm);
        const match = CITIES.find((c) => cand.includes(norm(c)));
        if (match && alive) { cached = match; setCity(match); }
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return city;
}
